/* unplugin-vue-components disabled */import __unplugin_components_0 from '/Users/Zhuanz/Desktop/project/oral-app/src/components/Tabbar.vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cross-container"
};
const _hoisted_2 = {
  class: "margin-right-10"
};
const _hoisted_3 = {
  class: "float-left margin-left-10"
};
const _hoisted_4 = {
  class: "margin-right-10"
};
const _hoisted_5 = {
  class: "float-left margin-left-10"
};
import { showImagePreview, showNotify } from 'vant';
import { getShipmentInfoApi } from '@/api/shipment';
export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  setup(__props) {
    const shipmentModel = ref();
    const route = useRoute();
    const onClickLeft = () => history.back();
    const img = ref('');
    const imagePreview = () => {
      showImagePreview({
        images: [img.value],
        closeable: true
      });
    };
    onMounted(async () => {
      const id = route.params.id;
      console.log(id);
      const res = await getShipmentInfoApi(id);
      if (res.code === 200) {
        shipmentModel.value = res.data;
        img.value = shipmentModel.value?.image ?? '';
      } else {
        showNotify({
          type: 'danger',
          message: res.msg
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_image = _resolveComponent("van-image");
      const _component_tabbar = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_van_nav_bar, {
        title: "出库详情",
        "left-arrow": "",
        onClickLeft: onClickLeft
      }), _createVNode(_component_van_cell, {
        title: "加工厂",
        value: _unref(shipmentModel)?.factoryName,
        class: "address-cell"
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "是否返工",
        value: _unref(shipmentModel)?.reworkName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "患者姓名",
        value: _unref(shipmentModel)?.name
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "手机号码",
        value: _unref(shipmentModel)?.phone
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "项目名称",
        value: _unref(shipmentModel)?.projectInfoName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "出库时间",
        value: _unref(shipmentModel)?.outboundTime
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "牙位信息"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_row, null, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(shipmentModel)?.rightTop), 1)]),
            _: 1
          }), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(_unref(shipmentModel)?.leftTop), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_van_row, null, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_4, _toDisplayString(_unref(shipmentModel)?.rightBottom), 1)]),
            _: 1
          }), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(shipmentModel)?.leftBottom), 1)]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_van_cell, {
        title: "附件"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_image, {
          width: "10rem",
          height: "10rem",
          fit: "contain",
          onClick: imagePreview,
          src: _unref(shipmentModel)?.image
        }, null, 8, ["src"])]),
        _: 1
      })]), _createVNode(_component_tabbar)], 64);
    };
  }
});